import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/loader';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function ConfirmUpdateDeltaTime({ visible = false, setVisible, handleSave, loading, title, mesages }) {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog open={visible} onClose={() => setVisible(false)} aria-labelledby="draggable-dialog-title">
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('notify')}
                </DialogTitle>
                <Loader loading={loading} />
                <DialogContent>
                    <DialogContentText>{t('message_confirm_update_time')}</DialogContentText>
                    <DialogContentText>{t('message_confirm')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        type="cancel"
                    />
                    <ButtonAction title={t('save')} type="save" onClick={handleSave} />
                </DialogActions>
            </Dialog>
        </div>
    );
}
